import React, { Component } from 'react';
import PostmanCollection from '../../../styles/docs/API Examples.postman_collection.json';
import PostmanEnv from '../../../styles/docs/API Examples.postman_environment.json';

class DocPostman extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    var postman_collection_data =
      'data:text/json;charset=utf-8,' +
      encodeURIComponent(JSON.stringify(PostmanCollection));
    var postman_environment_data =
      'data:text/json;charset=utf-8,' +
      encodeURIComponent(JSON.stringify(PostmanEnv));

    return (
      <div className="bucket" id="top">
        <div>
          <h3 className="heading-1" id="postman-setup">
            Postman Setup
          </h3>
          <div className="description">
            This step-by-step guide shows you how to set up Postman to interact
            with an API. It covers downloading Postman files, importing
            collection and environment files, configuring environment variables,
            and authorizing requests.
          </div>

          <h4 className="heading-2" id="download-postman">
            Download Postman
          </h4>

          <ol className="indented-list">
            <li>
              Visit the following URL to download the necessary Postman files:
              <ul>
                <li>
                  <a href="https://www.postman.com/downloads" target="_blank">
                    https://www.postman.com/downloads
                  </a>
                </li>
              </ul>
            </li>
            <li>
              Click on the provided link to access the Postman download page.
            </li>
            <li>
              Choose the appropriate version for your operating system and
              follow the installation instructions.
            </li>
          </ol>

          <h4 className="heading-2" id="download-the-postman-collection">
            Download the Postman collection
          </h4>

          <p>
            Download the following Postman collection and environment files:
          </p>

          <table className="table-wrapper enrich">
            <thead className="table-header enrich">
              <tr>
                <th>File </th>
                <th>Description </th>
              </tr>
            </thead>
            <tbody className="table-body">
              <tr>
                <td className="attribute">
                  <a
                    href={postman_collection_data}
                    className="link-button"
                    download="API Examples.postman_collection.json"
                  >
                    <span className="fa fa-file">&nbsp;</span>
                    API Examples.postman_collection.json
                  </a>
                </td>
                <td className="meaning">
                  Postman collection of Finch For Text API examples.
                </td>
              </tr>
              <tr>
                <td className="attribute">
                  <a
                    href={postman_environment_data}
                    className="link-button"
                    download="API Examples.postman_environment.json"
                  >
                    <span className="fa fa-file">&nbsp;</span>
                    API Examples.postman_environment.json
                  </a>
                </td>
                <td className="meaning">
                  Postman environment file for the Finch For Text collection.
                  <br />
                  <br />
                  Here you can specify your API key.
                </td>
              </tr>
            </tbody>
          </table>
          <div className="example-content host">
            NOTE: Your Finch For Text API key may not support all the features
            provided in the Postman examples.
          </div>
        </div>

        <h4 className="heading-2">
          Import the collection and environment files
        </h4>

        <ol className="indented-list">
          <li>Once Postman is installed, open the application.</li>
          <li>
            In Postman, go to <strong>File</strong> &gt;
            <strong>Import</strong> &gt; <strong>Choose Files</strong> and
            select the downloaded files to import.
            <ul>
              <li>
                Once imported, you will find a collection of API request
                examples under the <strong>Collections</strong> tab on the left
                side of the app.
              </li>
            </ul>
          </li>
        </ol>

        <h4 className="heading-2">Set environment variables</h4>

        <ol className="indented-list">
          <li>
            Click on <strong>Environments</strong> in the left panel.
          </li>
          <li>Select the environment file you imported previously.</li>
          <li>
            Set the <strong>initial</strong> and <strong>current value</strong>{" "}
            for
            <code>api-key</code> to your API key.
          </li>
          <li>Save the environment file to apply the change.</li>
        </ol>
        <h4 className="heading-2">Select the environment</h4>
        <ol className="indented-list">
          <li>
            In the top-right corner of the app, click the drop-down.
            <ul>
              <li>The environment you imported previously should be listed.</li>
            </ul>
          </li>
          <li>
            Click the imported environment to select it.
            <ul>
              <li>Postman will now apply your API key to your requests.</li>
            </ul>
          </li>
        </ol>
        <p>
          You are now ready to make Finch For Text API requests using Postman.
        </p>
      </div>
    );
  }
}

export default DocPostman;
